import * as textsTypes from '../types/Texts';
import * as errorActions from './Error';
import * as apiCalls from '../api/ApiCalls';

export function getTexts() {
    return async (dispatch) => {
        dispatch(getTextsRequest());
        try {
            dispatch(errorActions.clearError());
            const response = await apiCalls.GetTexts();
            const result = await response.json();
            if(response.status===200) {
                return dispatch(getTextsSuccess(result));
            }
            else{
                return dispatch(errorActions.throwNewError("Błąd pobierania danych",result.exceptionMessage));
            }
            
        } catch (error) {
            dispatch(errorActions.throwNewError("Błąd pobierania danych",error.message));
        }
    };
} 

export function getTextsRequest() {
    return {
        type: textsTypes.GET_TEXTS_REQUEST
    };
}

export function getTextsSuccess(texts) {
    return {
        type: textsTypes.GET_TEXTS_SUCCESS,
        payload: texts
    };
}


// WEBPACK FOOTER //
// ./src/actions/Texts.js